export default __webpack_public_path__ + "static/media/UGlogo.2c65bcbf.png";